import axios from "../axiosInstance";
import type {
  ListLibraryModulesParams,
  ListLibraryModulesResponse,
} from "@/modules/learningCenter/features/ModuleLibrary/types/libraryModule.types";

/**
 * Fetch library modules with optional filtering and pagination
 */
export const fetchLibraryModules = async (
  params: ListLibraryModulesParams = {}
): Promise<ListLibraryModulesResponse> => {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append("page", params.page.toString());
  if (params.page_size) queryParams.append("page_size", params.page_size.toString());
  if (params.status) queryParams.append("status", params.status);
  if (params.difficulty_level) queryParams.append("difficulty_level", params.difficulty_level);
  if (params.search) queryParams.append("search", params.search);
  if (params.skill_ids?.length) queryParams.append("skill_ids", params.skill_ids.join(","));
  if (params.tags?.length) queryParams.append("tags", params.tags.join(","));
  if (params.created_by_id) queryParams.append("created_by_id", params.created_by_id.toString());
  if (params.sort_by) queryParams.append("sort_by", params.sort_by);
  if (params.sort_order) queryParams.append("sort_order", params.sort_order);

  const queryString = queryParams.toString();
  const url = `/api/learning-center/module-library${queryString ? `?${queryString}` : ""}`;

  const response = await axios.get<ListLibraryModulesResponse>(url);
  return response.data;
};

export default fetchLibraryModules;
